import { useState, useCallback } from 'react'
import { CurrencyContext } from '@/contexts/currency-context'
import { formatCurrency, convertFromDKK, type SupportedCurrency } from '@/lib/format'

const STORAGE_KEY = 'cellarwise-currency'

function loadCurrency(): SupportedCurrency {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && ['DKK', 'EUR', 'USD', 'GBP', 'CHF'].includes(stored)) {
      return stored as SupportedCurrency
    }
  } catch {
    // localStorage unavailable
  }
  return 'DKK'
}

export function CurrencyProvider({ children }: { children: React.ReactNode }) {
  const [currency, setCurrencyState] = useState<SupportedCurrency>(loadCurrency)

  const setCurrency = useCallback((c: SupportedCurrency) => {
    setCurrencyState(c)
    try {
      localStorage.setItem(STORAGE_KEY, c)
    } catch {
      // localStorage unavailable
    }
  }, [])

  const formatValue = useCallback(
    (value: number | null) => {
      if (value === null || value === 0) return formatCurrency(value, currency)
      return formatCurrency(convertFromDKK(value, currency), currency)
    },
    [currency],
  )

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, formatValue }}>
      {children}
    </CurrencyContext.Provider>
  )
}
